import React, { createContext, ReactNode, useContext } from "react";
import { Salesarea, useFetchSalesareaQuery } from "../../../../store/api/upsellApi";

const salesareaDefault: Salesarea = {
  id: 0,
  naam: "",
  menuSalesareaId: 0,
  extra_settings: {
    showLangselLanguages: [],
  },
  mainLanguage: "en",
};
export function useSalesareaCtx() {
  return useContext(SalesareaContext) ?? salesareaDefault;
}

const SalesareaContext = createContext<Salesarea | undefined>(salesareaDefault);

export function SalesareaProvider({ children, salesareaId }: { children: ReactNode; salesareaId?: number }) {
  const { data } = useFetchSalesareaQuery(salesareaId ?? 0, {
    skip: salesareaId == null,
  });
  if (salesareaId != null) {
    salesareaDefault.id = salesareaId;
  }

  return <SalesareaContext.Provider value={data?.data}>{children}</SalesareaContext.Provider>;
}
